import React, { useEffect, useState } from "react";

interface INavigationLinks {
  links: ILink[];
}
interface ILink {
  id: string;
  title: string;
}
const useNavigationLinks = (props: INavigationLinks) => {
  const { links } = props;
  const [navLinks, setNavLinks] = useState<ILink[]>(links);
  const [removedLinks, setRemovedLinks] = useState<ILink[]>([]);

  useEffect(() => {
    const newLinks: any = [];
    for (const link of links) {
      if (removedLinks.findIndex((rL) => rL.title === link.title) === -1) {
        newLinks.push(link);
      }
    }
    setNavLinks(newLinks);
  }, [removedLinks]);

  return { navLinks, removedLinks, setRemovedLinks };
};

export default useNavigationLinks;
